module.exports = __webpack_public_path__ + "media/images/benefit-check-f6503b1af516d323806b600111a07a00.svg";